"use strict";

angular.module("core")
.directive("elementReady", function($rootScope, $timeout) {
    return {
        restrict: "A",
        link: function(scope, element, attrs) {
            $timeout(function() {
                element.ready(function () {
                    scope.$apply(function () {
                        $rootScope.$broadcast(attrs.elementReady + ":ready");
                    });
                });
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/element-ready/element-ready.directive.js
// module id = 512
// module chunks = 0